import React from 'react';
import { ContentWrapper } from '../../utils/components';
import Citroen from '../../../assets/images/2pk.jpg';
import Fiat from '../../../assets/images/500.jpeg';
import Kever from '../../../assets/images/kever.jpeg';
import Mazda from '../../../assets/images/mx5.jpg';
import Ami from '../../../assets/images/ami2.png';
import Drie from '../../../assets/images/drie.png';

import '../../styles/Portfolio.css';

const Portfolio = () => (
  <section className="section portfolio-section">
    <ContentWrapper>
      <div className="portfolio-wrapper">
        <h2 className="title portfolio-title">Portfolio</h2>
        <p className="portfolio-text">
          Bij ons leeft de passie voor wagens niet alleen in het heden, maar ook in het verleden. 
          We hebben door de jaren heen al verschillende oldtimers mogen restaureren, van carrosserie tot motorische revisie. 
          Elk project wordt met de grootste zorg en vakmanschap aangepakt, waarbij originaliteit en kwaliteit centraal staan. 
          Of het nu gaat om een volledige restauratie of specifieke herstellingen, we denken graag met je mee. 
          Heb je een oldtimer en wil je hem terug in zijn oude glorie herstellen? Neem dan gerust contact met ons op voor een vrijblijvend gesprek.
        </p>

        <div className="restore-list">
          <div className="restore-item">
            <img src={Citroen} alt="Citroën 2CV" className="car-image" />
          </div>
          <div className="restore-item">
            <img src={Fiat} alt="Fiat 500" className="car-image" />
          </div>
          <div className="restore-item">
            <img src={Mazda} alt="Mazda MX5" className="car-image" />
          </div>
          <div className="restore-item">
            <img src={Kever} alt="Volkswagen Kever" className="car-image" />
          </div>
          <div className="restore-item">
            <img src={Ami} alt="Ami" className="car-image" />
          </div>
          <div className="restore-item">
            <img src={Drie} alt="Drie oldtimers" className="car-image" />
          </div>
        </div>
      </div>
    </ContentWrapper>
  </section>
);

export default Portfolio;
